import { Box, CircularProgress } from '@mui/material';

interface LoadingComponentProps {
  isMinHeight?: boolean;
  size?: number;
}

const LoadingComponent = ({ isMinHeight, size  }: LoadingComponentProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: isMinHeight ? '200px' : '100vh',
      }}
    >
      <CircularProgress color="primary" size={size ?? 40}/>
    </Box>
  );
};
    
export default LoadingComponent;